import RUF from "../../../util/redux";

export function metaSetCurrentApplicant(state, action) {
  return RUF.updateObject(state, {
    meta: RUF.updateObject(state.meta, {
      currentApplicant: parseInt(action.payload)
    })
  });
}
